/**
 * Saved BOMs for Chip-seek.
 * Build a line list, save it in localStorage and re-submit later. Records are
 * browser-local; official RFQ responses come by email.
 */
(function () {
  if (window.icsSavedBomsAttached) return;
  window.icsSavedBomsAttached = true;

  const STORAGE_KEY = "ics_saved_boms";
  const MAX_BOMS = 30;

  const app = document.querySelector("[data-saved-boms-app]");
  if (!app) return;

  const lineList = app.querySelector("[data-bom-lines]");
  const lineEmpty = app.querySelector("[data-bom-lines-empty]");
  const nameInput = app.querySelector("[data-bom-name]");
  const addLineButton = app.querySelector("[data-bom-add-line]");
  const clearLinesButton = app.querySelector("[data-bom-clear-lines]");
  const saveButton = app.querySelector("[data-bom-save]");
  const submitButton = app.querySelector("[data-bom-submit]");
  const savedList = app.querySelector("[data-saved-boms-list]");
  const savedEmpty = app.querySelector("[data-saved-boms-empty]");
  const countElement = app.querySelector("[data-bom-count]");
  const status = app.querySelector("[data-bom-status]");
  const email = app.dataset.email || "sales@chip-seek.com";

  let workingLines = [];

  function readBoms() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeBoms(boms) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(boms));
    } catch (error) {
      // Storage unavailable; keep session behavior.
    }
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatDate(value) {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  function defaultBomName() {
    const now = new Date();
    return "BOM " + now.toISOString().slice(0, 10);
  }

  function showStatus(message, isError) {
    if (!status) return;
    status.textContent = message;
    status.hidden = false;
    if (isError) {
      status.setAttribute("data-error", "true");
    } else {
      status.removeAttribute("data-error");
    }
  }

  function renderLines() {
    if (!lineList) return;
    if (!workingLines.length) {
      lineList.hidden = true;
      if (lineEmpty) lineEmpty.hidden = false;
      if (clearLinesButton) clearLinesButton.hidden = true;
      if (submitButton) submitButton.disabled = true;
      return;
    }
    lineList.hidden = false;
    if (lineEmpty) lineEmpty.hidden = true;
    if (clearLinesButton) clearLinesButton.hidden = false;
    if (submitButton) submitButton.disabled = false;
    lineList.innerHTML = workingLines
      .map(function (line, index) {
        return (
          '<li class="ics-bom-line" data-bom-line data-index="' + index + '">' +
          '<span class="ics-bom-line__mpn">' + escapeHtml(line.mpn) + "</span>" +
          '<span class="ics-bom-line__qty">Qty ' + escapeHtml(line.qty) + "</span>" +
          (line.note ? '<span class="ics-bom-line__note">' + escapeHtml(line.note) + "</span>" : "") +
          '<button type="button" class="ics-bom-line__remove" data-bom-line-remove="' + index + '">Remove</button>' +
          "</li>"
        );
      })
      .join("");
  }

  function renderSaved() {
    const boms = readBoms();
    if (!savedList) return;
    if (!boms.length) {
      savedList.hidden = true;
      if (savedEmpty) savedEmpty.hidden = false;
      if (countElement) countElement.textContent = "0";
      return;
    }
    savedList.hidden = false;
    if (savedEmpty) savedEmpty.hidden = true;
    if (countElement) countElement.textContent = String(boms.length);
    savedList.innerHTML = boms
      .map(function (bom, index) {
        const lines = bom.lines || [];
        return (
          '<li class="ics-saved-bom" data-saved-bom data-index="' + index + '">' +
          '<div class="ics-saved-bom__main">' +
          "<strong>" + escapeHtml(bom.name || defaultBomName()) + "</strong>" +
          '<span class="ics-saved-bom__meta">' +
          lines.length + " lines · " + escapeHtml(formatDate(bom.createdAt)) +
          "</span>" +
          '<span class="ics-saved-bom__preview">' +
          escapeHtml(lines.slice(0, 3).map(function (line) { return line.mpn; }).join(", ")) +
          (lines.length > 3 ? " +" + (lines.length - 3) + " more" : "") +
          "</span>" +
          "</div>" +
          '<div class="ics-saved-bom__actions">' +
          '<button type="button" class="ics-saved-bom__action" data-bom-load="' + index + '">Load</button>' +
          '<button type="button" class="ics-saved-bom__action" data-bom-submit-saved="' + index + '">Submit</button>' +
          '<button type="button" class="ics-saved-bom__action" data-bom-duplicate="' + index + '">Duplicate</button>' +
          '<button type="button" class="ics-saved-bom__action ics-saved-bom__action--danger" data-bom-delete="' + index + '">Delete</button>' +
          "</div>" +
          "</li>"
        );
      })
      .join("");
  }

  function addLineFromInputs() {
    const mpnInput = app.querySelector("[data-bom-line-mpn]");
    const qtyInput = app.querySelector("[data-bom-line-qty]");
    const noteInput = app.querySelector("[data-bom-line-note]");
    const mpn = String(mpnInput ? mpnInput.value : "").trim();
    const qty = String(qtyInput ? qtyInput.value : "").trim();
    if (!mpn || !qty) {
      showStatus("Enter both the part number and quantity before adding a line.", true);
      return;
    }
    workingLines.push({
      mpn: mpn,
      qty: qty,
      note: String(noteInput ? noteInput.value : "").trim(),
    });
    if (mpnInput) mpnInput.value = "";
    if (qtyInput) qtyInput.value = "";
    if (noteInput) noteInput.value = "";
    renderLines();
    showStatus("Line added to the working BOM.", false);
  }

  function saveWorkingBom(duplicateSource) {
    if (!workingLines.length && !duplicateSource) {
      showStatus("Add at least one line before saving the BOM.", true);
      return;
    }
    const boms = readBoms();
    const name = String(nameInput ? nameInput.value : "").trim() || defaultBomName();
    const lines = duplicateSource ? duplicateSource.lines.slice() : workingLines.slice();
    boms.unshift({
      name: name,
      lines: lines,
      createdAt: new Date().toISOString(),
    });
    writeBoms(boms.slice(0, MAX_BOMS));
    renderSaved();
    showStatus("BOM saved on this device. Use Submit to send it to the sourcing team.", false);
  }

  function mailtoForBom(bom) {
    const lines = (bom.lines || [])
      .map(function (line) {
        return line.mpn + (line.qty ? " | Qty " + line.qty : "") + (line.note ? " | " + line.note : "");
      })
      .join("\n");
    const subject = "BOM RFQ: " + (bom.name || defaultBomName());
    const body =
      "BOM RFQ from the Chip-seek Saved BOMs page.\n\n" +
      (bom.name ? "BOM name: " + bom.name + "\n" : "") +
      "Lines:\n" + lines +
      "\n\nPlease confirm availability, pricing and lead time for each line.";
    return (
      "mailto:" +
      encodeURIComponent(email) +
      "?subject=" +
      encodeURIComponent(subject) +
      "&body=" +
      encodeURIComponent(body)
    );
  }

  function submitWorking() {
    if (!workingLines.length) {
      showStatus("Add at least one line before submitting.", true);
      return;
    }
    const bom = {
      name: String(nameInput ? nameInput.value : "").trim() || defaultBomName(),
      lines: workingLines.slice(),
    };
    showStatus("Your email draft is ready. Send it to reach the sourcing team.", false);
    window.location.href = mailtoForBom(bom);
  }

  if (addLineButton) {
    addLineButton.addEventListener("click", addLineFromInputs);
  }

  if (clearLinesButton) {
    clearLinesButton.addEventListener("click", function () {
      workingLines = [];
      renderLines();
      showStatus("Working lines cleared.", false);
    });
  }

  if (saveButton) {
    saveButton.addEventListener("click", function () {
      saveWorkingBom(null);
    });
  }

  if (submitButton) {
    submitButton.addEventListener("click", submitWorking);
  }

  if (lineList) {
    lineList.addEventListener("click", function (event) {
      const remove = event.target.closest("[data-bom-line-remove]");
      if (!remove) return;
      const index = Number(remove.dataset.bomLineRemove);
      if (Number.isFinite(index) && workingLines[index]) {
        workingLines.splice(index, 1);
      }
      renderLines();
    });
  }

  if (savedList) {
    savedList.addEventListener("click", function (event) {
      const boms = readBoms();
      const load = event.target.closest("[data-bom-load]");
      const submitSaved = event.target.closest("[data-bom-submit-saved]");
      const duplicate = event.target.closest("[data-bom-duplicate]");
      const del = event.target.closest("[data-bom-delete]");

      if (load) {
        const index = Number(load.dataset.bomLoad);
        if (Number.isFinite(index) && boms[index]) {
          workingLines = (boms[index].lines || []).slice();
          if (nameInput) nameInput.value = boms[index].name || "";
          renderLines();
          showStatus("BOM loaded into the working list.", false);
          window.scrollTo({ top: app.getBoundingClientRect().top + window.scrollY - 140, behavior: "smooth" });
        }
        return;
      }
      if (submitSaved) {
        const index = Number(submitSaved.dataset.bomSubmitSaved);
        if (Number.isFinite(index) && boms[index]) {
          showStatus("Your email draft is ready. Send it to reach the sourcing team.", false);
          window.location.href = mailtoForBom(boms[index]);
        }
        return;
      }
      if (duplicate) {
        const index = Number(duplicate.dataset.bomDuplicate);
        if (Number.isFinite(index) && boms[index]) {
          const copy = Object.assign({}, boms[index], {
            name: "Copy of " + (boms[index].name || defaultBomName()),
            createdAt: new Date().toISOString(),
          });
          const next = readBoms();
          next.unshift(copy);
          writeBoms(next.slice(0, MAX_BOMS));
          renderSaved();
          showStatus("BOM duplicated.", false);
        }
        return;
      }
      if (del) {
        const index = Number(del.dataset.bomDelete);
        if (Number.isFinite(index) && boms[index]) {
          const next = readBoms();
          next.splice(index, 1);
          writeBoms(next);
          renderSaved();
        }
      }
    });
  }

  renderLines();
  renderSaved();
})();
